import React from 'react'

const ICON = {
    width: "31",
    height: "31",
    colors: {
        company: "#87D72A",
        candidate: "#0D7AB6"
    }
};

const IconStar = ({ event, iconType, variant }) => {

    return( 
        variant === "outline" ?
            <svg onClick={event} width={ICON.width} height={ICON.height} viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0)">
                    <path d="M15.9415 22.9038L15.4813 22.6653L15.0212 22.9038L7.55337 26.7739L8.97587 18.5984L9.06704 18.0744L8.68352 17.7059L2.67102 11.9287L10.9936 10.7366L11.5117 10.6623L11.746 10.1943L15.4813 2.73369L19.2166 10.1943L19.4509 10.6623L19.969 10.7366L28.2917 11.9287L22.2791 17.7059L21.8956 18.0744L21.9868 18.5984L23.4093 26.7739L15.9415 22.9038Z" stroke={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company} strokeWidth="2"/>
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="31" height="28.9333" fill="white"/>
                    </clipPath>
                </defs>
            </svg> :
            <svg onClick={event} width={ICON.width} height={ICON.height} viewBox="0 0 31 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M15.5 21.6565L8.08359 25.5L9.5 17.3594L3.5 11.5942L11.7918 10.4065L15.5 3L19.2082 10.4065L27.5 11.5942L21.5 17.3594L22.9164 25.5L15.5 21.6565Z" fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company} stroke={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company} strokeWidth="2"/>
            </svg>
    )
}
export default IconStar;
